import { z } from 'zod/v4';

// Generic pattern for visualizations with groups
export const createGroupedVisualizationSchema = <TGroup extends z.ZodTypeAny, TAdditional extends z.ZodRawShape = {}>(
    groupSchema: TGroup,
    additionalOptions?: TAdditional,
) => {
    const base = z.object({
        groups: z.array(groupSchema).default([]),
    });

    return additionalOptions ? base.extend(additionalOptions).strip() : base.strip();
};

// Type helper for grouped visualization options
export type InferGroupedVisualizationOptions<
    TGroup extends z.ZodTypeAny,
    TAdditional extends z.ZodRawShape = {},
> = z.infer<ReturnType<typeof createGroupedVisualizationSchema<TGroup, TAdditional>>>;
